import { FunctionComponent, ReactNode } from 'react'
import { Tab } from '@headlessui/react'
import { ProductDetails } from './ProductDetails'
import { ProductMaterials } from './ProductMaterials'
import styles from './ProductTabs.module.css'

type TabSpec = {
  key: string
  label: string
  content: ReactNode
}

export const ProductTabs: FunctionComponent = () => {
  const tabs: TabSpec[] = [
    {
      key: 'productTabs_tabDetails',
      label: 'Details',
      content: <ProductDetails />,
    },
    {
      key: 'productTabs_tabMaterials',
      label: 'Materials & Size Guide',
      content: <ProductMaterials />,
    },
  ]

  return (
    <div>
      <Tab.Group>
        <Tab.List className={styles.tabList}>
          {tabs.map(({ key, label }) => (
            <Tab key={key} className={styles.label}>
              {label}
            </Tab>
          ))}
        </Tab.List>

        <Tab.Panels>
          {tabs.map(({ key, content }) => (
            <Tab.Panel key={key} className={styles.panel}>
              {content}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  )
}
